import { render, staticRenderFns } from "./EditVideoConference.vue?vue&type=template&id=9f5cd270&scoped=true&"
import script from "./EditVideoConference.vue?vue&type=script&lang=js&"
export * from "./EditVideoConference.vue?vue&type=script&lang=js&"
import style0 from "./EditVideoConference.vue?vue&type=style&index=0&id=9f5cd270&scoped=true&lang=css&"
import style1 from "./EditVideoConference.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5cd270",
  null
  
)

export default component.exports